module.exports = __webpack_public_path__ + "static/media/ws.096fc500.svg";